<table class="widget-data">
  <ng-container *ngFor="let row of rows.toArray()">
    <ng-container *ngTemplateOutlet="row.template"></ng-container>
  </ng-container>
</table>
